import { useSuspenseQuery } from '@tanstack/react-query';

import { getDictionaryValidationHistoryOptions } from '@/module/Author/Dictionary/Validation/model/DictionaryValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface DictionaryValidationHistoryProps {
  dictionaryId: Id;
}

export function DictionaryValidationHistory({ dictionaryId }: DictionaryValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getDictionaryValidationHistoryOptions(dictionaryId));

  return <ValidationHistoryContent history={history} />;
}
